import { useState } from 'react';
import Lottie from 'lottie-react';
import LottieLoading from '@/assets/LottieLoading.json';
import IconAlert from '@/components/common/IconAlert';

const NoRelatedData = () => {
  const [show, setShow] = useState(true);

  return (
    <div className="justify-content-center align-items-center">
      <IconAlert
        show={show}
        onClose={() => {
          setShow(false);
        }}
        variant="warning"
        className="mb-4"
        dismissible
      >
        <p className="mb-0 text-justify pe-3">
          برای نمایش کلمات در این تب لطفا ابتدا از منوی سمت راست وارد بخش ردیاب
          کلمات بشید و سپس کلمات مد نظر خودتون رو اضافه کنید و روی دکمه
          به‌روزرسانی کلیک کنید، سپس این تب به صورت خودکار کلمات مرتبط رو اضافه
          میکنه.
        </p>
      </IconAlert>
      <div
        className="mb-3 text-center"
        style={{ width: '250px', margin: 'auto' }}
      >
        <Lottie animationData={LottieLoading} />
      </div>
      <div className="mt-6 fw-medium text-center"></div>
    </div>
  );
};

export default NoRelatedData;
